import { Container, Group, Text, Title } from '@mantine/core';
import { NotFoundIllustration } from './NotFoundIllustration';
import classes from './NotFound.module.css';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Container className={classes.root}>
      <div className={classes.inner}>
        <NotFoundIllustration className={classes.image} />
        <div className={classes.content}>
          <Title className={classes.title}>Nothing to see here</Title>
          <Text size='lg' ta='center' className={classes.description}>
            The page you are looking for does not exist.
          </Text>
          <Group justify='center' mt='xl'>
            <button className='primary-button' onClick={() => navigate('/')}>
              Take me home
            </button>
          </Group>
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
